/* src/modules/dashboard/Scene.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import { map } from 'lodash';
import LessonTypeCard from './cards/LessonTypeCard';
import PopularCoursesCard from './cards/PopularCoursesCard';
import NumberOfLessonsCard from './cards/NumberOfLessonsCard';
import NumberOfUsersCard from './cards/NumberOfUsersCard';
import { getCreditsData, getLessonPriceData } from './selectors';
import { loadTexts } from '../../config/texts';

import {
  fetchDashboardLessons,
  fetchDashboardUsers,
  fetchDashboardStudents,
  fetchDashboardTutors,
  fetchPopularCourses,
} from './actions';

const TEXT_KEY = "dashboard";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      texts: loadTexts(TEXT_KEY, props.locale)
    };
    this._onFetchData = this._onFetchData.bind(this);
  }

  componentDidMount() {
    const { selectedOrganization, selectedUniversity } = this.props;
    this._onFetchData({ selectedOrganization, selectedUniversity });
  }

  componentWillReceiveProps(nextProps) {
    const { selectedOrganization, selectedUniversity } = nextProps;
    if (selectedUniversity !== this.props.selectedUniversity
      || selectedOrganization !== this.props.selectedOrganization)
      this._onFetchData({ selectedOrganization, selectedUniversity });
  }

  _onFetchData({ selectedOrganization, selectedUniversity }) {
    const universities = [selectedUniversity];
    const organizations = [selectedOrganization];
    return Promise.all([
      this.props.fetchDashboardLessons({ lessonSearchInput: {
        universities,
        organizations,
      } }),
      this.props.fetchDashboardUsers({ userSearchInput: {
        _universities: universities,
        _organizations: organizations,
      } }),
      this.props.fetchDashboardStudents({ studentSearchInput: {
        _universities: universities,
        _organizations: organizations,
      } }),
      this.props.fetchPopularCourses({
        organization: selectedOrganization,
        university: selectedUniversity,
        limit: 10,
      }),
      this.props.fetchDashboardTutors({ tutorSearchInput: {
        _universities: universities,
        _organizations: organizations,
      } }),
    ]);
  }

  renderCreditsBehavior() {
    const { classes, creditsData } = this.props;
    const { texts } = this.state;

    return (
      <div>
        <Typography variant="subheading">
          {texts.credits_behavior}
        </Typography>
        <div className={classes.creditsContainer}>
          {map(creditsData, d => (
            <div className={classes.creditsData}>
              <Typography variant="display2">
                {d.value.split(' ')[0]}
              </Typography>
              <Typography variant="subheading" style={{ marginTop: 10 }}>
                {d.field}
              </Typography>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderGeneralLessonStats() {
    const { classes, lessonsData } = this.props;

    return (
      <div className={classes.creditsContainer}>
        {map(lessonsData, d => (
          <div className={classes.creditsData}>
            <Typography variant="display2">
              {d.value.split(' ')[0]}
            </Typography>
            <Typography variant="subheading" style={{ marginTop: 10 }}>
              {d.field}
            </Typography>
          </div>
        ))}
      </div>
    )
  }

  render() {
    const { classes } = this.props;
    const { texts } = this.state;

    return (
      <div>
        <Grid className={classes.root} container spacing={16} alignItems="flex-end">
          <Grid item xs={12} sm={8}>
            {this.renderCreditsBehavior()}
          </Grid>
          <Grid item xs={12} sm={7}>
            <NumberOfUsersCard />
          </Grid>
          <Grid item xs={12} sm={5}>
            <PopularCoursesCard />
          </Grid>
        </Grid>
        <Grid className={classes.root} container spacing={16} alignItems="flex-start">
          <Grid item xs={12} sm={12}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography variant="subheading">
                {texts.lessons}
              </Typography>
              <div className={classes.line} />
            </div>
          </Grid>
          <Grid item xs={12} sm={8}>
            {this.renderGeneralLessonStats()}
          </Grid>
          <Grid item xs={12} sm={4}>
            <LessonTypeCard />
          </Grid>
          <Grid item xs={12}>
            <NumberOfLessonsCard />
          </Grid>
          {/*}<Grid item xs={12}>
            <ProfitCard />
          </Grid> */}
        </Grid>
      </div>
    );
  }
}

const styles = () => ({
  root: {
    flexGrow: 1,
    padding: 25
  },
  empty: {
    height: 100,
    backgroundColor: 'white',
  },
  creditsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  creditsData: {
    marginRight: 40,
    alignItems: 'center',
    marginTop: 20,
    marginBottom: 40,
    display: 'flex',
    flexDirection: 'column',
  },
  line: {
    backgroundColor: 'black',
    height: 1,
    width: '90%',
    marginTop: 25,
    marginBottom: 25,
  },
});

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  selectedUniversity: PropTypes.string.isRequired,
  selectedOrganization: PropTypes.string.isRequired,
  fetchDashboardLessons: PropTypes.func.isRequired,
  fetchDashboardUsers: PropTypes.func.isRequired,
  fetchDashboardStudents: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  selectedUniversity: state.auth.selectedUniversity,
  selectedOrganization: state.auth.selectedOrganization,
  creditsData: getCreditsData(state),
  lessonsData: getLessonPriceData(state),
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  fetchDashboardLessons: params => dispatch(fetchDashboardLessons(params)()),
  fetchDashboardUsers: params => dispatch(fetchDashboardUsers(params)()),
  fetchDashboardStudents: params => dispatch(fetchDashboardStudents(params)()),
  fetchDashboardTutors: params => dispatch(fetchDashboardTutors(params)()),
  fetchPopularCourses: params => dispatch(fetchPopularCourses(params)()),
});

export default compose(
  withStyles(styles, { name: 'Dashboard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(Dashboard);



// WEBPACK FOOTER //
// ./src/modules/dashboard/Scene.js